// extracted by mini-css-extract-plugin
export default {"container":"BranchDiscountClient_container__F41Wu","progressContainer":"BranchDiscountClient_progressContainer__w7hHn"};